export default __webpack_public_path__ + "static/media/login.94a560d6.svg";